import Permission from '@services/Permission';
import { canUserAccess } from '@/utils/user';

export default class {
  api_token = '';
  created_at = '';
  email = '';
  first_name = '';
  full_name = '';
  id = '';
  last_name = '';
  media = '';
  phone_number = '';
  role = '';
  suspended = '';
  total_balance = '';
  business = {
    location: {
      lat: '',
      lng: '',
      name: '',
    },
    trips: [],
    trip_ids: [],
    name: '',
    website: '',
  };
  constructor(data = {}) {
    Object.assign(this, data);
  }
  can(action, entity) {
    let role = this.role;

    return canUserAccess(role, action, entity);
  }
  isTourismOperator() {
    return this.role === 'tourism-operator';
  }

  getBalance() {
    return this.total_balance.currency(2);
  }

  hasBalance() {
    return Boolean(this.getBalance());
  }

  changeBalance(balance) {
    this.total_balance = (
      this.total_balance.currency() + balance.currency()
    ).currency(2);
    if (balance < 0) {
      $showSuccess(
        `$${Math.abs(
          balance
        )} has been reduced from your total balance. New Balance - $${this.total_balance.currency(
          2
        )}`,
        'Payout Successful',
        'payment-toast'
      );
    } else {
      $showSuccess(
        `$${Math.abs(
          balance
        )} has been added to your total balance. New Balance - $${this.total_balance.currency(
          2
        )}`,
        'Payment Successful',
        'payment-toast'
      );
    }
  }

  isAdmin() {
    return this.role === 'admin';
  }

  isTourist() {
    return this.role === 'tourist';
  }
}
